export { passengersTextModel } from './model';
